import { nanoid } from "nanoid";
import React from "react";
import GaugeChart from "react-gauge-chart/dist/GaugeChart";
import { addTopic, removeTopic } from "../../utils/socket.services";
import { getOneThing } from "../../utils/useful";


class ValueWidget extends React.Component {

    state = {
        data: {},
        thing: {},
        topicId: nanoid(10)
    }


    componentDidMount() {
        this.init()
    }

    componentDidUpdate(prevProps) {
        if (prevProps.data?.thing != this.props.data?.thing) {
            this.init()
        }
    }

    componentWillUnmount() {
        removeTopic(this.state.topicId, this.props.data.thing, 'things')
    }

    init() {
        this.setState({ thing: {}, data: {} }, () => {
            getOneThing({ id: this.props.data.thing }, (fetchResult, fetchError, status) => {
                // console.log(fetchResult)
                if (fetchResult) {
                    this.setState({ thing: fetchResult.info, data: fetchResult.info.latestData ?? {} })
                }

                addTopic(this.state.topicId, this.props.data.thing, 'things', null, this.updateData)
            })
        })
    }


    updateData = (newData) => {
        let data = this.state.data
        data = { ...data, ...newData }
        this.setState({ data })
        // console.log("updateData")
    }


    getLabel(dataObject) {
        // console.log(dataObject)
        if (this.state.thing?.structure) {
            // let result = ''
            for (let i = 0; i < this.state.thing.structure.length; i++) {
                const structure = this.state.thing.structure[i];
                if (structure.dataObject == dataObject) {
                    return structure.label
                }
            }

        }
    }

    getUnit(index) {
        if (this.props.data?.unit) {
            let units = this.props.data?.unit ? this.props.data?.unit : ''
            units = units.split(',')
            return units[index]
        } else {
            return ''
        }
    }

    render() {
        return (
            <div className="w-100 flexcc" style={{ flex: 1, flexDirection: 'column' }} >
                <div className="row w-100">
                    {this.props.data?.characteristic && this.props.data.characteristic.map((prop, index) => {
                        let col = this.props.data.characteristic.length > 1 ? '6' : '12'
                        if ((index + 1 == this.props.data.characteristic.length) && (((index + 1) % 2) != 0)) {
                            col = '12'
                        }
                        return (
                            <div className={"text-center mb-2 col-12 col-md-" + col} >
                                <div style={{ backgroundColor: '#f2f6f8', padding: '20px 10px ', borderRadius: 4 }}>
                                    <p className="text-bold " style={{ fontSize: 30 }}>{this.state.data[prop] != null ? (this.state.data[prop] + this.getUnit(index)) : "N/A"}</p>
                                    <p className="text-normal">{this.getLabel(prop)}</p>
                                </div>
                            </div>

                        )
                    })}
                </div>
            </div >
        )
    }
}



// const mapStateToProps = state => ({ topics: state.topics })
// const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

// export default connect(
//     mapStateToProps,
//     mapDispatchToProps
// )(ValueWidget);

export default ValueWidget

